import Button from '@mui/material/Button';
import MuiSnackbar from 'components/MuiExtras/Snackbar/MuiSnackbar';
import { MuiSnackbarVariant } from 'components/MuiExtras/Snackbar/MuiSnackbarContent';
import { ISnackbarProviderProps, SnackbarContextProvider, SnackbarHandleActionType, WithSnackbarParamsType } from 'components/SnackbarProvider/Snackbar';
import * as React from 'react';

interface IMessage {
    message: React.ReactNode;
    variant?: MuiSnackbarVariant;
    actionTitle?: string;
    handleAction?: SnackbarHandleActionType;
}

interface IState {
    queue: IMessage[];
}

export default class SnackbarProvider extends React.PureComponent<ISnackbarProviderProps, IState> {
    private timer: NodeJS.Timeout = null;
    private contextValue: WithSnackbarParamsType;

    constructor(props: ISnackbarProviderProps) {
        super(props);
        this.state = { queue: [] };
        this.contextValue = { showMessage: (m, v, t, a) => this.showMessage(m, v, t, a) }
    }

    /**
     * Display a message with this snackbar.
     * @param {string} message message to display
     * @param {string} [title] label for the action button
     * @param {function} [handleAction] click handler for the action button
     * @public
     */
    showMessage(message: React.ReactNode, variant: MuiSnackbarVariant = "info", actionTitle: string = null, handleAction: SnackbarHandleActionType = null): void {

        var newQueue = this.state.queue.concat({ message, variant, actionTitle, handleAction });

        this.setState({
            queue: newQueue
        });

        if (newQueue.length > 0 && this.timer == null) {
            this.timer = setInterval(() => {
                this.handleClose(null, "timeout");
            }, 10000);
        }
    }

    private handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {

        if (reason === 'clickaway') {
            return;
        }

        var newQueue = this.state.queue.slice(1);

        if (newQueue.length == 0) { clearInterval(this.timer); this.timer = null; };

        this.setState({ queue: newQueue });
    };


    render() {
        const { queue } = this.state;

        const { children, SnackbarProps } = this.props;

        var data = queue.length == 0 ? null : queue[0];

        return (
            <>
                <SnackbarContextProvider value={this.contextValue}>
                    {children}
                </SnackbarContextProvider>

                {
                    data &&
                    <MuiSnackbar
                        {...SnackbarProps}
                        open
                        variant={data.variant}
                        message={data.message}
                        onClose={this.handleClose}
                        action={
                            data.actionTitle == null
                                ? null
                                : <Button
                                    color='secondary'
                                    size='small'
                                    onClick={
                                        (e) => {
                                            this.handleClose(e, null);
                                            if (data.handleAction) data.handleAction();
                                        }
                                    }
                                >
                                    {data.actionTitle}
                                </Button>
                        }
                    />
                }
            </>
        );
    }
}